module.exports = __webpack_public_path__ + "static/img/banner03.3cc6385.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner03.jpg
// module id = EcMp
// module chunks = 1